import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { StyledFormLabel } from 'components/atoms';
import {
  RadioFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import { FC, useState } from 'react';

export const RadioButtonField: FC<
  RadioFieldProps<any> & withGridItemCSS & withWrapperCSS
> = ({
  error,
  disabled = false,
  fieldKey,
  gridItemCss,
  initValue,
  label = '',
  onChange = noop,
  options,
  labelCss,
  required = false,
  row = false,
  wrapperCss,
  xs = 12,
}) => {
  const [value, setValue] = useState(initValue);

  const optionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    onChange(event.target.value, fieldKey);
  };

  return (
    <Grid item xs={xs} style={gridItemCss}>
      <FormControl
        error={!!error}
        required={required}
        style={{ width: '100%', ...wrapperCss }}
      >
        <StyledFormLabel error={!!error} style={labelCss}>
          {label}
          {required ? '*' : null}
        </StyledFormLabel>
        <RadioGroup value={value} onChange={optionChange} row={row}>
          {options.map((option, i) => (
            <FormControlLabel
              key={`radio-option-${option.name}-${i}`}
              disabled={disabled}
              control={<Radio />}
              value={option.name}
              label={option.description}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Grid>
  );
};
